(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AddClass = /*#__PURE__*/function () {
  function AddClass(selecteur) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, AddClass);
    this.options = Object.assign({
      openClass: "open"
    }, options);
    selecteur.forEach(function (el) {
      document.addEventListener('click', function (event) {
        var isElementClick = el.contains(event.target);
        if (isElementClick) {
          if (el.classList.contains(_this.options.openClass)) {
            _this.hide(el);
          } else {
            _this.show(el);
          }
        } else {
          _this.hide(el);
        }
      });
    });
  }
  _createClass(AddClass, [{
    key: "show",
    value: function show(el) {
      el.classList.add(this.options.openClass);
    }
  }, {
    key: "hide",
    value: function hide(el) {
      el.classList.remove(this.options.openClass);
    }
  }]);
  return AddClass;
}();
var _default = AddClass;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
// class App {
//   constructor () {
//     console.info('ES6 Modules work!');
//   }
// }

// export default App;
"use strict";

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BackTop = /*#__PURE__*/function () {
  function BackTop(selecteur) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, BackTop);
    this.selecteur = selecteur;
    this.options = Object.assign({
      type: "slide--bottom" // options default
      // onShow: ()=>{}
    }, options);

    // this.options.onShow()
    this.selecteur.classList.add('backTop__' + this.options.type, 'hide');
    this.selecteur.addEventListener('click', this.handleClick);
    window.addEventListener('scroll', function (e) {
      return _this.handleScroll(e);
    });
  }
  _createClass(BackTop, [{
    key: "handleClick",
    value: function handleClick() {
      window.scrollTo({
        top: 100
      });
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        this.selecteur.classList.remove("hide");
      } else {
        this.selecteur.classList.add("hide");
      }
    }
  }]);
  return BackTop;
}();
var _default = BackTop;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FixedMenu = /*#__PURE__*/function () {
  function FixedMenu() {
    var _this = this;
    _classCallCheck(this, FixedMenu);
    this.content = document.querySelector('.fixed-menu__content');
    this.btn = document.querySelector('.fixed-menu__show');
    this.declancheur = document.querySelector('.fixed-menu');
    this.btn.addEventListener('click', function () {
      return _this.open();
    });
    document.querySelector('.fixed-menu__title').addEventListener('click', function () {
      return _this.hide();
    });
  }
  _createClass(FixedMenu, [{
    key: "open",
    value: function open() {
      gsap.to(this.declancheur, {
        width: '100%'
      });
      gsap.to(this.content, {
        x: '0'
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      gsap.to(this.declancheur, {
        width: '0%'
      });
      gsap.to(this.content, {
        x: '-100%'
      });
    }
  }]);
  return FixedMenu;
}();
var _default = FixedMenu;
exports["default"] = _default;

},{}],5:[function(require,module,exports){
"use strict";

var _app = _interopRequireDefault(require("./app.js"));
var _backTop = _interopRequireDefault(require("./backTop.js"));
var _sliders = _interopRequireDefault(require("./sliders.js"));
var _fixedMenu = _interopRequireDefault(require("./fixedMenu.js"));
var _tabs = _interopRequireDefault(require("./tabs.js"));
var _menu = _interopRequireDefault(require("./menu.js"));
var _addClass = _interopRequireDefault(require("./addClass"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var backTop = new _backTop["default"](document.querySelector('#topButton'), {
  type: "slide--bottom" // slide--bottom, slide--right, zoom, fade
  // onShow: ()=>{
  //     console.log('hello')
  // }
});

// if (document.querySelector('.video-js')) {
//     const video = videojs('player', {
//         language: 'fr'
//     })
// }

// const sliders = new Slider(document.querySelectorAll('.splide'));
// const fixedMenu = new FixedMenu();
// const tabs = new Tabs(document.querySelectorAll('.tabs'));

var dropdown = new _addClass["default"](document.querySelectorAll('.dropdown'), {
  openClass: "dropdown--open"
});
var pagination = new _addClass["default"](document.querySelectorAll('.pagination__item'), {
  openClass: "pagination__select"
});

},{"./addClass":1,"./app.js":2,"./backTop.js":3,"./fixedMenu.js":4,"./menu.js":6,"./sliders.js":7,"./tabs.js":8}],6:[function(require,module,exports){
"use strict";

// const menu = document.querySelector('.menu');
// const logo = document.querySelector('.menu__logo img');
var wrapper = document.querySelector('.menu__wrapper');
var burger = document.querySelector('.menu__burger');
var menuMain = document.querySelector('.menu__main');
var i = 0;

// function darkLogo(){
//     logo.setAttribute('src','./assets/images/logo.png')
// }

// function lightLogo(){
//     logo.setAttribute('src','./assets/images/logo-bl.png')
// }

// function checkInnerWidth(){
//     if(innerWidth <= 768 ){
//         darkLogo()
//         gsap.to( menu , {
//             position : 'sticky',
//         } )

//     }else{
//         lightLogo()
//         menuMain.classList.remove('menu__main--hidden')
//         gsap.to( menu , {
//             position : 'absolute',
//         } )
//         // gsap.to( '.menu .link' , {
//         //     color : 'white',
//         // } )
//     }
// }

// ScrollTrigger.create({
//     trigger: menu,
//     start:  "top -50px",
//     onEnter: () => {
//         menu.classList.add('menu__bgColor')
//         // darkLogo()
//         gsap.to( menu , {
//             position : 'fixed',
//         } )
//         // gsap.to( '.menu .link' , {
//         //     color : 'var(--color3-500)',
//         //     duration: 0
//         // } )
//     },
//     onEnterBack: () => {
//         menu.classList.remove('menu__bgColor')
//         checkInnerWidth()

//     }
// })

// window.addEventListener('resize', () => { 
//     checkInnerWidth()
// });

// checkInnerWidth()
menuMain.style.top = wrapper.clientHeight + 'px';
burger.addEventListener('click', function () {
  if (i % 2 == 0) {
    burger.classList.add('menu__burger--open');
    menuMain.classList.add('menu__main--open');
  } else {
    burger.classList.remove('menu__burger--open');
    menuMain.classList.remove('menu__main--open');
  }
  i++;
});

},{}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Slider = /*#__PURE__*/_createClass(function Slider(selecteur) {
  _classCallCheck(this, Slider);
  selecteur.forEach(function (el) {
    var options = {
      perPage: 3,
      arrows: true
    };
    if (el.classList.contains('splide__navigation')) {
      options = {
        perPage: 4,
        arrows: false
      };
    }
    var _options = options,
      perPage = _options.perPage,
      arrows = _options.arrows;
    new Splide(el, {
      type: 'loop',
      autoplay: false,
      perPage: perPage,
      perMove: 1,
      pagination: true,
      paginationDirection: 'ttb',
      arrows: arrows,
      gap: '2rem',
      breakpoints: {
        520: {
          perPage: 1
        },
        767: {
          perPage: 2
        },
        1023: {
          gap: '1rem'
        }
      }
    }).mount();
  });
});
var _default = Slider;
exports["default"] = _default;

},{}],8:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Tabs = /*#__PURE__*/_createClass(function Tabs(selecteur) {
  _classCallCheck(this, Tabs);
  var i = 1;
  selecteur.forEach(function (el) {
    gsap.set(el, {
      className: 'tabs tabs-' + i++
    });
    var btns = document.querySelectorAll('tabs-' + i + '.tab');
    console.log(btns);
    btns.forEach(function (element) {
      element.addEventListener('click', function () {
        gsap.set(btns, {
          className: 'tab'
        });
        gsap.set(element, {
          className: 'tab active'
        });
      });
    });
  });
});
var _default = Tabs;
exports["default"] = _default;

},{}]},{},[5]);
